var AttributesListView = require("./AttributesListView");
var AttributesEditView = require("./AttributesEditView");
var Controller = require("common/Controller");
var Utils = require("common/Utils");

/**
 * @class
 * @extends {Controller}
 */
function AttributesController() {
    Controller.call(this);

    var listView = new AttributesListView();
    var attrEditView = new AttributesEditView();
    var self = this;

    var currentCategory;

    listView.addChildView(attrEditView);

    /**
     * @override
     * @inheritDoc
     */
    this.getId = function() {
        return "AttributesController";
    };

    self.subscribeTo("show-attributes-view", function(data) {
        showEditView(data.category);
    });

    self.subscribeToChannel("Electron", "show-attributes-list-view", function() {
        self.showAttributesListView();
    });

    self.subscribeTo("update-attributes", function(data) {
        self.updateAttributes(data.changes);
    });

    this.showAttributesListView = function() {
        currentCategory = undefined;

        CudaLaunch.models.attributes.getCategories()
            .then(function(categories) {
                listView.setCategories(categories);
                self.showView(listView);
            });
    };

    function showEditView(category) {
        currentCategory = category;

        CudaLaunch.models.attributes.getAttributes(category)
            .then(function(attributes) {
                attrEditView.setCategory(category, attributes);
                self.showView(attrEditView);
            });
    }

    /**
     * @override
     * @inheritDoc
     */
    this.getViews = function() {
        return [listView, attrEditView];
    };

    this.updateAttributes = function(submitData) {
        //Remove any current error flags
        $(".warningIcon").removeClass("warningIcon");

        CudaLaunch.models.attributes.updateAttributes(submitData)
            .done(function() {
                if (submitData.hasOwnProperty("session")) {
                    // As you can't enter a bad session password (i.e. no validation) we don't need to worry about partial successes
                    var session = CudaLaunch.serverConfiguration.getSession();
                    var sessionAttrs = submitData["session"];

                    for (var i = 0; i < sessionAttrs.length; i++) {
                        var sessionAttr = sessionAttrs[i];

                        if (sessionAttr.hasOwnProperty("name") && sessionAttr.hasOwnProperty("value")) {
                            var key = sessionAttr["name"];
                            var val = sessionAttr["value"];

                            if (val === "") {
                                delete session.completedAuthSchemes[key];
                            } else {
                                var pattern = /^\*+$/; // test for unchanged password fields i.e. ********

                                if (!pattern.test(val)) {
                                    session.completedAuthSchemes[key] = val;
                                }
                            }
                        }
                    }
                }
                self.showPreviousView();
            })
            .fail(function(data) {
                var errors = "";

                if (data.responseJSON && data.responseJSON.validationErrors) {
                    var errorsJson = data.responseJSON.validationErrors;

                    for (var i = 0; i < errorsJson.length && i < 5; i++) {
                        var errMsg = errorsJson[i].errorMsg.trim();
                        var i18nMsg = $.t("common::" + errMsg, {defaultValue : errMsg}); // Pre 7.0 the server responded with a non internationalized message
                        errors += i18nMsg + "<br>";
                        var $li = $("input[name='" + errorsJson[i].field + "']").closest("li");
                        $li.addClass("warningIcon");
                    }
                } else {
                    errors = $.t("common::error.title");
                }
                CudaLaunch.controllers.RootController.showErrorDialog(errors, true, "#attributesSaveButton");
            });
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getState = function() {
        return (currentCategory) ? {category : currentCategory} : {};
    };

    /**
     * @override
     * @inheritDoc
     */
    this.setState = function(state) {
        if (state.category) {
            CudaLaunch.models.attributes.getCategories()
                .then(function(categories) {
                    listView.setCategories(categories);
                    showEditView(state.category);
                });
        } else {
            self.showAttributesListView();
        }
    };
}

Utils.inherits(AttributesController, Controller);

module.exports = AttributesController;


//////////////////
// WEBPACK FOOTER
// ./attributes/AttributesController.js
// module id = 48
// module chunks = 0